import {
  BigNumberCard,
  PeriodSelect,
  Shadow,
  Text,
  HStack,
  Stack,
  VStack,
} from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { ScrollView } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { useHomeActions } from '../../../../../../store/home/capture/actions';
import { selectedBigNumbersYearState, yearsState } from '../../../../../../store/home/capture/atom';
import { getHomeValueVisibility } from '../../../../../../store/home/capture/selector';
import { customerConversionFunnel } from '../../../../../../store/home/conversion/selector';

export interface ConversionBigNumbersProps {
  isMobile: boolean;
  isTablet: boolean;
}

export const ConversionBigNumbers: React.FC<ConversionBigNumbersProps> = ({
  isMobile,
  isTablet,
}) => {
  const valueVisible = useRecoilValue(getHomeValueVisibility);
  const { setSelectedBigNumbersYear } = useHomeActions();
  const { data: yearSelected } = useRecoilQuery(selectedBigNumbersYearState);
  const { data: years } = useRecoilQuery(yearsState);

  const {
    data: conversionFunnelData,
    loading: conversionFunnelLoading,
    refresher: refresherConversionFunnel,
    error: errorConversionFunnel,
  } = useRecoilQuery(customerConversionFunnel);

  const bigNumbersContent = (
    <HStack
      space={Spacing['inline.xxxs']}
      mt={Spacing['stack.nano']}
      mb={Spacing['stack.xxxs']}
      width="100%">
      <BigNumberCard
        isLoading={conversionFunnelLoading}
        iconName="PreRegister"
        label="PRÉ CADASTRO"
        onReload={refresherConversionFunnel}
        hasError={!!errorConversionFunnel}
        isVisible={valueVisible}
        hasShadow
        value={conversionFunnelData?.data.preRegistrations || 0}
        flex={1}
        customMask={(value) => `${value}`}
      />
      <BigNumberCard
        isLoading={conversionFunnelLoading}
        iconName="Registrations"
        label="CADASTROS INICIADOS"
        onReload={refresherConversionFunnel}
        hasError={!!errorConversionFunnel}
        isVisible={valueVisible}
        hasShadow
        value={conversionFunnelData?.data.inProgressRegistrations || 0}
        flex={1}
        customMask={(value) => `${value}`}
      />
      <BigNumberCard
        isLoading={conversionFunnelLoading}
        iconName="FileSearch"
        label="CADASTROS PENDENTES"
        onReload={refresherConversionFunnel}
        hasError={!!errorConversionFunnel}
        isVisible={valueVisible}
        hasShadow
        value={conversionFunnelData?.data.pendingRegistrations || 0}
        flex={1}
        customMask={(value) => `${value}`}
      />
      <BigNumberCard
        isLoading={conversionFunnelLoading}
        iconName="Lock"
        label="CONTAS BLOQUEADAS"
        onReload={refresherConversionFunnel}
        hasError={!!errorConversionFunnel}
        isVisible={valueVisible}
        hasShadow
        value={conversionFunnelData?.data.accountsBlocked || 0}
        flex={1}
        customMask={(value) => `${value}`}
      />
      <BigNumberCard
        isLoading={conversionFunnelLoading}
        iconName="Clients"
        label="TOTAL DE CLIENTES"
        onReload={refresherConversionFunnel}
        hasError={!!errorConversionFunnel}
        isVisible={valueVisible}
        hasShadow
        value={conversionFunnelData?.data.approvedRegistrations || 0}
        flex={1}
        customMask={(value) => `${value}`}
      />
    </HStack>
  );

  const content =
    isMobile || isTablet ? (
      <Stack>
        <ScrollView horizontal persistentScrollbar={false} showsHorizontalScrollIndicator={false}>
          {bigNumbersContent}
        </ScrollView>
      </Stack>
    ) : (
      bigNumbersContent
    );

  return (
    <Shadow
      level={1}
      borderRadius={BoxBorder.heavy}
      p={Spacing['inset.xs']}
      pb={0}
      overflow="hidden">
      <VStack flex={1}>
        <HStack justifyContent="space-between">
          <Text variant="semibold">FUNIL DE CLIENTES</Text>
          <HStack space={Spacing['inline.quarck']}>
            <PeriodSelect
              p={0}
              label="Período"
              placeholder="Ano"
              periodOptions={years?.map((year) => ({ label: year, value: year })) || []}
              selectedPeriod={yearSelected || ''}
              onPeriodChange={setSelectedBigNumbersYear}
            />
          </HStack>
        </HStack>
        {content}
      </VStack>
    </Shadow>
  );
};
